const NavigationMenu = ({ children }) => (
    <div className='fixed inset-x-0 top-0 z-40 flex h-12 shrink-0 items-center border-b border-gray-200 bg-white shadow-xs'>
        {children}
    </div>
);

export default NavigationMenu;
